<template>
  <div class="unidentified-object-icon" :style="cssVars">
    <unidentified-object-safe v-if="isSafe" />
    <unidentified-object-caution v-else-if="isCaution" />
    <unidentified-object-danger v-else />
  </div>
</template>

<script>
import UnidentifiedObjectSafe from "./UnidentifiedObjectSafe.vue";
import UnidentifiedObjectCaution from "./UnidentifiedObjectCaution.vue";
import UnidentifiedObjectDanger from "./UnidentifiedObjectDanger.vue";
import C from "../../../Constants";
const { CAUTION, DANGER, SAFE } = C.RG_RISK_LEVEL;

export default {
  name: "UnidentifiedObjectIcon",
  components: {
    UnidentifiedObjectCaution,
    UnidentifiedObjectSafe,
    UnidentifiedObjectDanger,
  },
  props: {
    riskLevel: {
      type: Number, // SAFE(0) | CAUTION(3) | DANGER(8)
      default: CAUTION,
    }, // 色の切り替え
    hasManualAssessment: {
      type: Boolean,
      default: false,
    }, // 枠の表示非表示を切り替え
  },
  computed: {
    isSafe() {
      return this.riskLevel === SAFE;
    },
    isCaution() {
      return this.riskLevel === CAUTION;
    },
    isDanger() {
      return this.riskLevel === DANGER;
    },
    cssVars() {
      const autoCognitionFrameDisplay = this.hasManualAssessment
        ? "none"
        : "block";
      return {
        "--auto-cognition-frame-display": autoCognitionFrameDisplay,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.unidentified-object-icon {
  --auto-cognition-frame-display: block;
  ::v-deep .auto-cognition-frame {
    display: var(--auto-cognition-frame-display);
  }
}
</style>
